<div class="container">
    <div class="title-container">
        <h2 class="mat-title" *ngIf="this.data.modalMode !== 'edit'">
            Création d'un Pack
        </h2>
        <h2 class="mat-title" *ngIf="this.data.modalMode === 'edit'">
            Édition du Pack : {{ this.data.pack.label }}
        </h2>
    </div>

    <div class="light-blue-horizontal-separator"></div>

    <div class="bloc-container-row">
        <!-- Pack -->
        <div class="bloc-container-pack">
            <h4 class="red-title">Pack</h4>
            <div class="inputs-container">
                <div class="tv-rect-input-extensible flex-auto">
                    <mat-form-field>
                        <mat-label>Nom du pack</mat-label>
                        <input
                            matInput
                            type="text"
                            [formControl]="packNameFormControl"
                        >
                    </mat-form-field>
                </div>
                <div class="tv-rect-input-extensible width-180px">
                    <mat-form-field>
                        <mat-label>Taux Def %</mat-label>
                        <input
                            matInput
                            type="number"
                            min="-100"
                            max="100"
                            [formControl]="packDefFormControl"
                        >
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="bloc-container-row-60-p">
         <!-- Chaines -->
        <div class="bloc-container-channel">
            <h4 class="red-title">Chaines</h4>
            <div class="inputs-container">
                <!-- Filtrer Chaines -->
                <div class="tv-round-input-extensible-no-label full-width">
                    <mat-form-field>
                        <mat-icon matPrefix>search</mat-icon>
                        <input
                            class="tv-ns-select-option"
                            matInput
                            type="text"
                            [formControl]="searchChannelFormControl"
                        >
                    </mat-form-field>
                </div>
            </div>

            <div *ngIf="isChannelListLoading" class="loader-container">
                <mat-spinner diameter="60" class="light-spinner"></mat-spinner>
            </div>

            <div *ngIf="!isChannelListLoading" class="bloc-container-list  tv-custom-always-visible-scroll-bar">
                <ng-container *ngIf="(filteredChannelList$ | async) as items">
                    <div *ngFor="let item of items; let i = index">
                        <div class="bloc-container-row custom-channel-row-adjustment">
                            <div class="bloc-container-row">
                                <mat-checkbox
                                    class="tv-ns-blue-checkbox"
                                    name="channel-{{item.id}}"
                                    [checked]="isChannelSelected(item)"
                                    (change)="onChannelSelectChange($event, item, i)"
                                ></mat-checkbox>
                                <img [src]="item.logo" fill alt="{{ item.name }}-logo" class="channel-logo" />
                                <span class="channel-name">{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Repartition -->
        <div class="bloc-container-share">
            <div class="red-title-container">
                <h4 class="red-title">Répartition</h4>
                <div class="red-info-container">
                    <mat-icon
                        class="red-icon"
                        *ngIf="selectedChannels.length > 0 && getTotalRate() != 100"
                        matTooltip="Le total de la répartition doit être égal à 100%"
                        matTooltipPosition="above"
                    >
                        error
                    </mat-icon>
                    <span class="red-title" *ngIf="selectedChannels.length > 0">{{ getTotalRate() }}%</span>
                </div>
            </div>
            <ng-container>
                <div
                    class="container-chips tv-custom-scroll-bar lateral-padding-l"
                    *ngIf="selectedChannels.length > 0"
                >
                    <div class="block-chip" *ngFor="let item of selectedChannels">
                        <img class="channel-logo" src="{{ item.logo }}" alt="logo"/>
                        <span>{{ item.name }} - {{ item.rate }} %</span>
                        <mat-icon (click)="removeChannelItem(item)">cancel</mat-icon>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="button-section">
        <button
            class="tv-ns-secondary-large-button-on-light-bg"
            (click)="closeDialog()"
        >
        Annuler
        </button>
        <button
            class="tv-ns-validation-large-button"
            [disabled]="isValidationButtonDisabled()"
            (click)="savePack()"
        >
        Valider
        </button>
    </div>
</div>
